import { COMPLIANCE_COUNTRIES, COUNTRY } from "../../constants/CountryConstant";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ComplianceDetails from "./steps/ComplianceDetails";
import ComponentDetails from "./steps/ComponentDetails";
import Documents from "./steps/Documents";
import EmployeeDetails from "./steps/EmployeeDetails";
import SalaryHistory from "./steps/SalaryHistory";

export default class EmployeeStepManager {
    static getAllCreationSteps(onClickHandler) {
        const countryCode = TenantService.get(TENANT.COUNTRY_CODE);
        let steps = [];

        const employeeDetails = {
            title: "EMPLOYEE_DETAILS",
            requiredProps: [],
            reqError: "Please fill all the mandatory details",
            getChild: (props) => (
                <EmployeeDetails
                    {...props}
                    // key={"1"}
                    userId={props.userId}
                    setData={props.setData}
                    ref={props.ref}
                    isEdit={props.isEdit}
                    isEditState={props.isEditState}
                />
            ),
            onClick: (event) => onClickHandler(event, 0),
        }

        const componentDetails = {
            title: "COMPONENT",
            requiredProps: ["columnConfig"],
            reqError: "Please fill all the mandatory details",
            getChild: (props) => (
                <ComponentDetails
                    {...props}
                    // key={"2"}
                    employeeData={props.employeeData}
                    employeeDetailedData={props.employeeDetailedData}
                    setData={props.setData}
                    ref={props.ref}
                    isEdit={props.isEdit}
                    isEditState={props.isEditState}
                />
            ),
            onClick: (event) => onClickHandler(event, 1),
        }

        const complianceDetails = {
            title: "COMPLIANCE_DETAILS",
            requiredProps: ["columnConfig"],
            reqError: "Please fill all the mandatory details",
            getChild: (props) => (
                <ComplianceDetails
                    {...props}
                    key={"3"}
                    userId={props.userId}
                    employeeData={props.employeeData}
                    employeeDetailedData={props.employeeDetailedData}
                    setData={props.setData}
                    ref={props.ref}
                    isEdit={props.isEdit}
                    isEditState={props.isEditState}
                />
            ),
            onClick: (event) => onClickHandler(event, 2),
        }

        const documents = {
            title: "Documents",
            requiredProps: ["columnConfig"],
            getChild: (props) => (
                <Documents
                    {...props}
                    setData={props.setData}
                />
            ),
            onClick: (event) => onClickHandler(event, 3),
        }
        const salaryHistory = {
            title: "Employee Update History",
            requiredProps: ["columnConfig"],
            getChild: (props) => (
                <SalaryHistory
                    {...props}
                    setData={props.setData}
                />
            ),
            onClick: (event) => onClickHandler(event, 4),
        }
        if (COMPLIANCE_COUNTRIES.includes(countryCode)) {
            steps = [employeeDetails, componentDetails, complianceDetails, documents, salaryHistory];
        } else {
            steps = [employeeDetails, componentDetails, documents, salaryHistory];
        }

        return steps;
    }
}
